




































/* General */
import Vue from 'vue'
import { debounce } from 'lodash'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IPriorityLevelForSelection } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'IfpFilterPriorities',

  props: {
    selectedIds: {
      type: Array as () => number[],
      required: true,
    },
    priorityOptions: {
      type: Array as () => IPriorityLevelForSelection[],
      required: true,
    },
  },

  data() {
    return {
      internalSelectedIDs: [] as number[],
      debounceEmitSelectedIDs: null,
      emitDebounceTimeForMultipleSelectionsInMS: 500,
    }
  },
  computed: {
    hasSelectedPriorities(): boolean {
      if (this.selectedIds.length === 0) {
        return false
      }

      return this.priorityOptions.some(p => this.selectedIds.includes(p.id))
    },
    hasOneSelectedPriority(): boolean {
      return this.selectedPriorities.length === 1
    },
    selectedPriorities(): IPriorityLevelForSelection[] {
      return this.priorityOptions.filter(p => this.selectedIds.includes(p.id))
    },
  },
  watch: {
    selectedIds: {
      immediate: true,
      handler(val) {
        this.internalSelectedIDs = val
      },
    },
  },
  created() {
    this.debounceEmitSelectedIDs = debounce(
      this._emitSelectedIDs,
      this.emitDebounceTimeForMultipleSelectionsInMS,
    )
  },
  methods: {
    isSelected(id: number) {
      return this.internalSelectedIDs.includes(id)
    },
    handleSelection(id: number) {
      if (this.internalSelectedIDs.includes(id)) {
        this._updateSelectedIDs(this.internalSelectedIDs.filter(i => i !== id))
      } else {
        this._updateSelectedIDs([...this.internalSelectedIDs, id])
      }
    },
    clearSelectedIDs() {
      /* Circumvent debounce and emit immediately */
      this._updateSelectedIDs([], true)
    },
    _updateSelectedIDs(ids: number[], emitImmediately?: boolean) {
      // Set this so the UI can instantly react to the updated IDs rather than waiting
      // for syncing on the selectedIds prop
      this.internalSelectedIDs = ids
      if (emitImmediately) {
        this._emitSelectedIDs()
      } else {
        this.debounceEmitSelectedIDs()
      }
    },
    _emitSelectedIDs() {
      this.$emit('selected-ids-updated', this.internalSelectedIDs)
    },
  },
})
